@let model = viewModel();

<article class="hd-gate-line-card">
  <span class="hd-gate-line-card__bg" aria-hidden="true">{{ model.gate }}</span>

  @if (hasExtra()) {
    <button
      type="button"
      class="hd-gate-line-card__toggle"
      [class.hd-gate-line-card__toggle--active]="showExtra()"
      [attr.aria-pressed]="showExtra()"
      [attr.aria-label]="showExtra() ? 'Extra info verbergen' : 'Extra info tonen'"
      [attr.title]="showExtra() ? 'Extra info verbergen' : 'Extra info tonen'"
      (click)="toggleExtra()"
    >
      <i class="fas" [class.fa-eye]="!showExtra()" [class.fa-eye-slash]="showExtra()" aria-hidden="true"></i>
    </button>
  }

  <header class="hd-gate-line-card__header">
    <div class="hd-gate-line-card__number-col">
      <div class="hd-gate-line-card__number">{{ model.lineNumber }}</div>
      <div class="hd-gate-line-card__gate-line">{{ model.gateLineLabel }}</div>
    </div>
    <div class="hd-gate-line-card__heading">
      @if (model.keynote) {
        <div class="hd-gate-line-card__keynote">{{ model.keynote }}</div>
      }
      @if (model.roleKeynote) {
        <div class="hd-gate-line-card__role-keynote">{{ model.roleKeynote }}</div>
      }
      @if (model.roleKeynote2) {
        <div class="hd-gate-line-card__role-keynote2">{{ model.roleKeynote2 }}</div>
      }
    </div>
  </header>

  <div class="hd-gate-line-card__body">
    @if (showRa() && showExtra() && model.subText) {
      <p class="hd-gate-line-card__subtext">{{ model.subText }}</p>
    }
    @if (showRa() && (model.learningAbout || (showExtra() && model.learningAboutExtended))) {
      <p class="hd-gate-line-card__learning">
        @if (model.learningAbout) {
          <span>{{ model.learningAbout }}</span>
        }
        @if (showExtra() && model.learningAboutExtended) {
          <span class="hd-gate-line-card__learning-extended"> {{ model.learningAboutExtended }}</span>
        }
      </p>
    }
    @if (showOwn() && model.ownDescription) {
      <!-- Eigen lijnbeschrijving (Mechanics in Motion): ◆ + amber-inkt. -->
      <hd-own-line-text class="hd-gate-line-card__own" [class.hd-gate-line-card__own--plain]="!model.learningAbout" [gate]="model.gate" [line]="model.lineNumber" field="description" [text]="model.ownDescription" />
    }
    @if (model.exaltation; as exaltation) {
      <hd-gate-line-duality-row
        [row]="exaltation"
        kind="exaltation"
        [gate]="model.gate"
        [line]="model.lineNumber"
        [showRa]="showRa()"
        [showCustom]="showAlternativeIChing()"
        [showOwn]="showOwn()"
      />
    }
    @if (model.detriment; as detriment) {
      <hd-gate-line-duality-row
        [row]="detriment"
        kind="detriment"
        [gate]="model.gate"
        [line]="model.lineNumber"
        [showRa]="showRa()"
        [showCustom]="showAlternativeIChing()"
        [showOwn]="showOwn()"
      />
    }
  </div>

  <footer class="hd-gate-line-card__footer">
    @if (model.icons.length > 0 || lineCompanionVisible() || classicIChingVisible()) {
      <div class="hd-gate-line-card__icons">
        @for (icon of model.icons; track icon.key) {
          <i
            class="fa-regular hd-gate-line-card__icon"
            [ngClass]="'fa-' + icon.faName"
            [class.is-visualisation-transparent]="icon.visualisation === 'transparent'"
            [title]="icon.label"
            [attr.aria-label]="icon.label"
          ></i>
        }
        @if (lineCompanionVisible()) {
          <!-- Line Companion (community-content): springt naar de boektekst van deze lijn. -->
          <button
            type="button"
            class="hd-gate-line-card__lc-button"
            [title]="lineCompanionLabel()"
            [attr.aria-label]="lineCompanionLabel()"
            (click)="openLineCompanion($event)"
          >
            <i class="fa-regular fa-book-open-lines hd-gate-line-card__icon hd-gate-line-card__icon--lc" aria-hidden="true"></i>
          </button>
        }
        @if (classicIChingVisible()) {
          <!-- Classic I Ching: springt naar de klassieke tekst van deze lijn. -->
          <button
            type="button"
            class="hd-gate-line-card__lc-button hd-gate-line-card__iching-button"
            [title]="classicIChingLabel()"
            [attr.aria-label]="classicIChingLabel()"
            (click)="openClassicIChing($event)"
          >
            <i class="fa-regular fa-scroll-old hd-gate-line-card__icon hd-gate-line-card__icon--lc" aria-hidden="true"></i>
          </button>
        }
      </div>
    }
    @if (model.zodiacStart || model.zodiacEnd) {
      <span class="hd-gate-line-card__zodiac">{{ model.zodiacStart }} - {{ model.zodiacEnd }}</span>
    }
  </footer>
</article>
